import shippingData from "../data/shipping";

const defaultState = {
  methods: {},
  selected: null,
  dest: null
};
export default function shipping(state = defaultState, action) {
  switch (action.type) {
    case "GET_SHIPPING_METHODS": {
      const { countryCode } = action;
      if (countryCode === "") return defaultState;
      const methods = shippingData[countryCode];
      const methodIds = Object.keys(methods);
      let selected = methodIds[0];
      for (let i = 0; i < methodIds.length; i++) {
        const method = methods[methodIds[i]];
        if (method.default) {
          selected = methodIds[i];
          break;
        }
      }
      return {
        ...state,
        methods,
        selected,
        dest: countryCode
      };
    }
    case "SELECT_SHIPPING_METHOD": {
      return {
        ...state,
        selected: action.id
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shipping.js